import Route from "vue-routisan";
import Home from "../views/Home.vue";
import About from "../views/About.vue";
import Service from "../views/Service.vue";
import Information from "../views/Information.vue";
import Result from "../views/result.vue";
import Test from "../views/test/index.vue";
import Announcement from "../views/Announcement.vue";

// define routes
Route.view("/", Home).options({
  name: "home",
  meta: {
    navTransparent: true
  }
});
Route.view("/about", About).options({
  name: "about",
  meta: {
    navTransparent: true
  }
});
Route.view("/service", Service).options({
  name: "service",
  meta: {
    navTransparent: true
  }
});
Route.view("/information", Information).options({
  name: "information",
  meta: {
    navTransparent: true
  }
});
// 公告
Route.view("/announcement", Announcement).options({
  name: "announcement",
  meta: {
    navTransparent: true
  }
});
Route.view("/test", Test).name("test");
Route.view("/result", Result).name("result");
const routeModules = require.context(
  // 其组件目录的相对路径
  "./",
  // 是否查询其子目录
  false,
  // 匹配基础组件文件名的正则表达式
  /(?<!index|routes)\.js$/
);
routeModules.keys().forEach(fileName => {
  const module = routeModules(fileName);
  const routeModule = module.default || module;
  routeModule(Route);
});

export default Route.all();
